import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactForm.css";

const ContactForm = () => {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_u3nz38p", // Replace with your EmailJS service ID
        "template_wf0igvg", // Replace with your EmailJS template ID
        form.current,
        "sG2-1HecxdWYo9onq" // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          setStatus("Message Sent Successfully!");
          form.current.reset();
        },
        (error) => {
          setStatus("Failed to Send Message. Try Again!");
          console.error(error.text);
        }
      );
  };

  return (
    <div className="contact-form-container">
      <h1>Get in Touch</h1>
      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <h2>Contact Us</h2>
        <div>
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" required />
        </div>
        <div>
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" required />
        </div>
        <div>
          <label htmlFor="subject">Subject</label>
          <input type="text" id="subject" name="subject" required />
        </div>
        <div>
          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" rows="5" required></textarea>
        </div>
        <button type="submit">Send Message</button>
        {status && <p className="status-message">{status}</p>}
      </form>
    </div>
  );
};

export default ContactForm;
